import React from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton";
import Educations from "../../containers/education/Educations";
import Certifications from "../../containers/certifications/Certifications";
import CompetitiveSites from "../../components/competitiveSites/CompetitiveSites";
import EducationImg from "./EducationImg";
import { Link } from "react-router-dom";
import { competitiveSites, certifications } from "../../portfolio";
import "./EducationComponent.css";

function Education({ theme, onToggle, isDark }) {
  const nightMode = isDark !== false;

  return (
    <div
      className={`education-main education-observatory ${
        nightMode ? "education-night" : "education-paper"
      }`}
    >
      <Header theme={theme} onToggle={onToggle} isDark={isDark} />

      <main className="education-page-shell">
        <div className="education-grid-field" aria-hidden="true" />
        <div
          className="education-aurora education-aurora-one"
          aria-hidden="true"
        />
        <div
          className="education-aurora education-aurora-two"
          aria-hidden="true"
        />

        <section
          className="education-hero"
          aria-labelledby="education-page-title"
        >
          <div className="education-hero-copy">
            <p className="education-kicker">
              <span className="education-status-dot" /> ACADEMIC ARCHIVE / 2020
              — PRESENT
            </p>
            <h1 id="education-page-title">
              Education is a<br />
              <em>long-range signal.</em>
            </h1>
            <p className="education-hero-description">
              Basic qualification and certifications, collected as proof that
              deep technical work starts with curious questions and compounds
              through practice.
            </p>
            <div className="education-hero-actions">
              <Link className="education-primary-link" to="/projects">
                View selected work <span>↗</span>
              </Link>
              <Link className="education-secondary-link" to="/opensource">
                GitHub activity <span>↗</span>
              </Link>
              <a className="education-scroll-link" href="#educations">
                Explore the record <span>↓</span>
              </a>
              <span className="education-hero-coordinate">
                <i /> NEW YORK · CHENNAI
              </span>
            </div>
          </div>

          <div
            className="education-orbit-stage"
            aria-label="Academic trajectory visualization"
          >
            <div
              className="education-orbit-ring education-orbit-ring-one"
              aria-hidden="true"
            />
            <div
              className="education-orbit-ring education-orbit-ring-two"
              aria-hidden="true"
            />
            <div className="education-orbit-path" aria-hidden="true" />
            <div className="education-orbit-card education-orbit-card-top">
              <span>2024 — 2026</span>
              <b>
                DATA
                <br />
                SCIENCE
              </b>
            </div>
            <div className="education-orbit-card education-orbit-card-bottom">
              <span>2020 — 2024</span>
              <b>
                ENGINEERING
                <br />
                FOUNDATION
              </b>
            </div>
            <div className="education-orbit-center">
              <div className="education-illustration">
                <EducationImg theme={theme} />
              </div>
              <span className="education-orbit-tag">LEARN / BUILD / SHARE</span>
            </div>
            <span
              className="education-orbit-beacon beacon-one"
              aria-hidden="true"
            />
            <span
              className="education-orbit-beacon beacon-two"
              aria-hidden="true"
            />
            <span
              className="education-orbit-beacon beacon-three"
              aria-hidden="true"
            />
          </div>
        </section>

        <section
          className="education-instrument-panel"
          aria-label="Academic highlights"
        >
          <div className="education-stat">
            <span>INSTITUTIONS</span>
            <strong>02</strong>
            <small>two lenses, one trajectory</small>
          </div>
          <div className="education-stat education-stat-featured">
            <span>MASTER&apos;S GPA</span>
            <strong>
              3.67<span>/4.0</span>
            </strong>
            <small>Stony Brook University</small>
          </div>
          <div className="education-stat">
            <span>RESEARCH OUTPUT</span>
            <strong>01</strong>
            <small>IEEE publication + patent</small>
          </div>
          <div className="education-signal-links">
            <p>EXTERNAL SIGNALS</p>
            <CompetitiveSites logos={competitiveSites.competitiveSites} />
          </div>
        </section>

        <section
          className="education-records-section"
          aria-labelledby="educations"
        >
          <div className="education-section-intro">
            <p className="education-kicker">
              <span /> FIELD RECORDS
            </p>
            <p>
              Formal study, applied experiments, and the projects that made the
              theory stick.
            </p>
          </div>
          <Educations theme={theme} isDark={isDark} />
        </section>

        {certifications.certifications.length > 0 ? (
          <section
            className="education-certifications-section"
            aria-labelledby="certs"
          >
            <div className="education-section-intro education-certifications-intro">
              <p className="education-kicker">
                <span /> VERIFIED SIGNALS
              </p>
              <p>
                A working collection of credentials across AI, cloud
                infrastructure, and systems engineering.
              </p>
            </div>
            <Certifications theme={theme} isDark={isDark} />
          </section>
        ) : null}
      </main>

      <Footer theme={theme} onToggle={onToggle} isDark={isDark} />
      <TopButton theme={theme} />
    </div>
  );
}

export default Education;
